export const getFilePlayerOptions = () => {
  const cookie = document.cookie
    .split('; ')
    .find((c) => c.startsWith('fileplayer='));
  if (!cookie) return {};

  return Object.fromEntries(
    cookie
      .split('=')[1]
      .split('&')
      .map((pair) => pair.split('=', 2)),
  );
};
